'use strict';

import './myAlerts.scss';
import template from './myAlerts.template.html';
import controller from './myAlerts.controller.js';

const component = {
    bindings: {},
    controller,
    template
};

export default component;
